import { useLocation, useNavigate, useParams } from "react-router-dom";

import { persistor } from "../../../store";
import { useDispatch } from "react-redux";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function LogoutPage() {
  const dispatch = useDispatch();
  function onLogout() {
    dispatch({
      type: "LOGOUT",
    });

    // Manually trigger storage event to sync across tabs
    window.localStorage.setItem('logout', Date.now().toString());
    window.localStorage.removeItem('logout');
    // navigate("login");
    // window.location.reload();
  }
  return (
    <>
      <button
        className="dropdown-item ai-icon btn btn-primary light"
        onClick={onLogout}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line
            x1="21"
            y1="12"
            x2="9"
            y2="12"
          ></line>
        </svg>
        <span className="ms-2 text-primar">Logout </span>
      </button>
    </>
  );
}

export default withRouter(LogoutPage);
